import { APP_URLS } from 'constants/urls';
import { BreadCrumb } from '@lib/components/BreadCrumbs/types';
import { BreadCrumbsOptions } from './types';

export default function getDashboardHomeItem({
  t,
}: Pick<BreadCrumbsOptions, 't'>): BreadCrumb {
  return {
    label: t('home-page'),
    path: APP_URLS.dashboard.home.getPathWithQuery(),
  };
}
